import { Injectable } from '@angular/core';
import {map} from "rxjs/operators";
import {HttpObservable, HttpWrapper} from "../../http-helpers/http.wrapper";
import {IChangePasswordRequest, IChangePasswordResponse} from "../types";

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordProxy {
  constructor(private httpWrapper: HttpWrapper) {
  }

  public changePassword(changePasswordRequest: IChangePasswordRequest): HttpObservable<IChangePasswordResponse> {
    return this.httpWrapper.putAnon('PatientPortalChangePassword', 'ChangePassword', changePasswordRequest);
  }
}
